import { FC, useMemo } from 'react';

import { Grid } from '@mui/material';

import { useAuthStore } from '../../../stores/auth';
import { NoResultsCard } from '../../molecules/NoResultsCard';
import { ProposalCard } from './ProposalCard';

// Main Difference from ProposalList is that this is populated by proposals under `auth/me` endpoint
// This will show under the `Related to me` Tab in VotingPage
export const UserProposalList: FC = () => {
  const user = useAuthStore((store) => store.user);
  const { proposals } = user || {};

  const reversedProposals = useMemo(() => proposals?.slice().reverse(), [proposals]);

  return (
    <>
      <Grid container spacing={2}>
        {reversedProposals?.length ? (
          reversedProposals.map((proposal) => (
            <Grid xs={12} item key={proposal._id}>
              <ProposalCard {...proposal} />
            </Grid>
          ))
        ) : (
          <NoResultsCard
            sx={{ width: '100%', ml: 2, mt: 3 }}
            title="No proposals found"
            subtitle="Please vote or comment on a proposal!"
          />
        )}
      </Grid>
    </>
  );
};
